import { PULSE_CONSENT_COOKIE_NAME, readCookie } from '../consent.js';

/** Cineamo's own banner: whether `__analysis_cookies_opt_in` is the literal `true`. */
export function readCookieConsent(): boolean {
    if (typeof document === 'undefined') return false;

    // `readCookie` rather than a third hand-rolled parse: only `tracker.ts` is barred from value
    // imports of `consent.js`, because the install-free CI step cannot resolve one there.
    return readCookie(document.cookie, PULSE_CONSENT_COOKIE_NAME) === 'true';
}
